import styled from 'styled-components';

export const VehicleAlertWrapper = styled.div`
  align-content: center;
  display: flex;
  justify-content: left;
  flex-direction: column;
  height: auto;
  margin-bottom: 25px;
  ${(props) => props.theme.font.label.v200};
  font-weight: ${(props) => props.theme.font.weight.v300};
`;

// Success Alert
export const PaidOffWrapper = styled.div`
  // green-2  https://showroom.cvnacorp.com/carvana-css-theme
  background-color: rgba(47, 158, 68, 0.1);
  color: #2f9e44;
  border-radius: ${(props) => props.theme.border.radius};
`;

// Overdue Alert
export const OverdueWrapper = styled.div`
  // green-2  https://showroom.cvnacorp.com/carvana-css-theme
  background-color: rgba(224, 49, 49, 0.1);
  color: #e03131;
  border-radius: ${(props) => props.theme.border.radius};
`;

// Overdue Alert
export const CommonStyles = styled.div`
  padding: 12px 20px;
  display: flex;
  align-items: center;
  svg {
    min-width: 16px;
  }
`;
